import Api from "../Api/Api"
import {getOrder} from "../GlobalReduxState/action";
import {ERROR_API_CALL, MANAGE_REGISTER_LOADING, MANAGE_STORE_DEL_OPT_LOADED, MANAGE_STORE_DEL_OPT_LOADING} from "../constants/action-types";

export function updateCarPlates(linkCode:any,plateNumbers: any, deliveryOption: any) {
    return(dispatch:any)=>{
        dispatch({type:MANAGE_REGISTER_LOADING, data: true});
        return Api.updateCarPlates(linkCode,plateNumbers,deliveryOption).then(()=>{
            dispatch({type:MANAGE_REGISTER_LOADING, data: false});
            return dispatch(getOrder(linkCode))
        }).catch(s=>{
            dispatch({type:MANAGE_REGISTER_LOADING, data: false});
        });
    }
}

export function updateOrder(orderCode:any, text:any, deliveryOption: any) {
    return () =>{
        Api.updateOrder(orderCode,text, deliveryOption).then(res=>console.log(res));
    }
}

export function getStoreDeliveryOptions(linkCode: any, storeId:number, preview:boolean) {
    return (dispatch: any) => {
        if (linkCode !== '#####' || preview) {
            dispatch({ type: MANAGE_STORE_DEL_OPT_LOADING })
            Api.getStoreDeliveryOptions(linkCode, storeId, preview)
                .then(response => {
                    if (!response.ok)
                        throw new Error(`Error querying service for delivery options for ${preview ? storeId : linkCode}`)
                    return response
                })
                .then(response => response.json())
                .then(data => dispatch({ type: MANAGE_STORE_DEL_OPT_LOADED, data }))
                .catch(() => dispatch({ type: ERROR_API_CALL, error: true }));
        }
    }
}
